import service from '@/utils/server';

const modName = '/home/main/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  })
};

export const getNotice = data => {
  return service({
    url: '/bd/notice/getAllNotice',
    method: 'post'
  });
}



// WEBPACK FOOTER //
// ./src/page/home/api/index.js